import includes from "lodash/includes"
import { USER_STATES } from "constants-lib/userState"

/**
 * Determines whether to show the rolloff link based on the user's state.
 *
 * @function
 * @param {string} userState - The user's state.
 * @returns {boolean} A boolean value indicating whether to show the rolloff link.
 *
 */
export const shouldShowRolloffLink = (userState) => {
  const userStates = [
    USER_STATES.LOGGED_IN,
    USER_STATES.LOGGED_IN_TRO_AVAILABLE,
    USER_STATES.LOGGED_IN_OMR_TRO,
    USER_STATES.LOGGED_IN_SMB_TRO,
    USER_STATES.LOGGED_IN_ALL_AVAILABLE,
  ]

  return (userState && includes(userStates, userState)) || false
}
